module.exports = __webpack_public_path__ + "img/phone.b4ee92c9.svg";